
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { GraduationCap, Home } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface RoleSelectorProps {
  onRoleSelect: (role: 'student' | 'landlord') => void;
}

const RoleSelector = ({ onRoleSelect }: RoleSelectorProps) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-4">
      <Card 
        className="p-6 cursor-pointer hover:shadow-md transition-shadow border-2 hover:border-primary/20"
        onClick={() => onRoleSelect('student')}
      >
        <div className="text-center space-y-4">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
            <GraduationCap className="h-8 w-8 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-lg">
              {t('i_am_student', 'أنا طالب', 'I am a Student')}
            </h3>
            <p className="text-sm text-muted-foreground">
              {t('student_desc', 'أبحث عن سكن بالقرب من جامعتي', 'Looking for housing near my university')}
            </p>
          </div>
        </div>
      </Card>

      <Card 
        className="p-6 cursor-pointer hover:shadow-md transition-shadow border-2 hover:border-primary/20"
        onClick={() => onRoleSelect('landlord')}
      >
        <div className="text-center space-y-4">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10">
            <Home className="h-8 w-8 text-accent" />
          </div>
          <div>
            <h3 className="font-semibold text-lg">
              {t('i_am_owner', 'أنا مالك', 'I am an Owner')}
            </h3>
            <p className="text-sm text-muted-foreground">
              {t('owner_desc', 'أريد تأجير عقاري للطلاب', 'I want to rent my property to students')}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RoleSelector;
